__turbopack_context__.v({
  "shimmer": "skeleton-module-scss-module__OHFBGq__shimmer",
  "skeleton": "skeleton-module-scss-module__OHFBGq__skeleton",
});
